import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'follow-up-list',
  name: '跟进列表',
  icon: '跟',
  group: 'CRM 组件',
  description: '展示待跟进客户或重点客户。',
  defaultProps: {
    title: '重点跟进',
    limit: 5
}
}
